import React, { useEffect } from "react";
import "../../scss/index.scss";
import { useNavigate } from "react-router-dom";
import { apiUsuario } from "../../api/usuario";
import { ENTORNO } from "../../utils/constantes";
import { isMobile } from "react-device-detect";
import {
  getIdioma,
  getemail,
  getpassword,
  setmenuAbajoSeleccionado,
  getrole,
} from "../../utils/variablesLocales";

const apiusuario = new apiUsuario();

export function Splash() {
  const navigate = useNavigate();

  const navigateToInicioPasajero = () => {
    setmenuAbajoSeleccionado("Inicio");
    navigate(ENTORNO.URL_APLICACION + "/Pasajero/Inicio");
  };

  const navigateToInicioConductor = () => {
    setmenuAbajoSeleccionado("Inicio");
    navigate(ENTORNO.URL_APLICACION + "/Conductor/Inicio");
  };

  const navigateToInicioAdministrador = () => {
    setmenuAbajoSeleccionado("Inicio");
    navigate(ENTORNO.URL_APLICACION + "/Administrador/Inicio");
  };

  useEffect(() => {
    (async () => {
      if (isMobile === true) {
        let Idioma = getIdioma();
        let email = getemail();
        let password = getpassword();

        if (
          email !== "undefined" &&
          password !== "undefined" &&
          email !== "null" &&
          password !== "null"
        ) {
          //login
          const response = await apiusuario.IngresarConPasswordEncriptado(
            email,
            password,
            Idioma
          );

          if (response === "Ok") {
            //ingresar a inicio
            if (getrole() === "Pasajero" && isMobile === true) {
              navigateToInicioPasajero();
            }

            if (getrole() === "Conductor" && isMobile === true) {
              navigateToInicioConductor();
            }

            if (getrole() === "Administrador") {
              navigateToInicioAdministrador();
            }
          }
        } else {
          navigate(ENTORNO.URL_APLICACION + "/SeleccionarIdioma");
        }
      }
    })();
  });

  return <div className="splash"></div>;
}
